// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.translation-buttons-container {
  margin: -20px 45px 0 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.translation-buttons-container-main {
  margin: -20px 45px 0 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  flex-direction: column;
}
.translation-buttons-container-main .button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 5px;
}
.translation-buttons-container-main .experimental-text {
  position: relative;
  bottom: -8px;
  right: 5px;
  display: flex;
  flex-direction: row;
  font-size: 0.7rem;
  justify-content: flex-end;
}

.translation-button {
  border-radius: 3px;
  background-color: white;
  border: 1px solid #0669B3;
  color: #0669B3;
  font-size: 0.7em;
  font-weight: 600;
  height: 22px;
  margin-left: 10px;
  transition: 0.1s ease;
  width: 80px;
}
.translation-button:hover {
  background: #63AEDE;
  color: white;
  color: black;
  font-weight: 500;
}
.translation-button:active {
  color: #D1D3D4;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/TranslationButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACE,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AAIF;;AAFA;EACE,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AAKF;AAJE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAMJ;AAJE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAMJ;;AAFA;EC7BI,kBD8BiC;EACnC,uBAAA;EACA,yBAAA;EACA,cDJW;ECKX,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AAKF;AAJE;EACE,mBDVY;ECWZ,YAAA;EACA,YAAA;EACA,gBAAA;AAMJ;AAJE;EACE,cDzBI;AC+BR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
